import numeral from 'numeral';

export const formatMoney = (number = 0) => {
    return numeral(number).format('$0,00.00');
};

export const formatMoneyFromPennies = (number = 0, showCurrency = true) => {
    return numeral(number / 100.0).format(showCurrency ? '$0,00.00' : '0,00.00');
};